import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { fg } from '@atlaskit/platform-feature-flags';
import { DisplayMode, RenderForm, useFormSaveErrorsActions } from '@atlassian/proforma-common-core/form-system';
import { CommonMessage, IntlCommonMessages, LoadingSpinner } from '@atlassian/proforma-common-core/jira-common';
import { portalCreateProductExperience } from '../common/utils/analytics';
import { FormRenderSuccess } from './form-render-success';
var PortalCreate = function PortalCreate(_ref) {
  var portalCreateStore = _ref.portalCreateStore,
    reporterAccountId = _ref.reporterAccountId,
    jiraFieldErrors = _ref.jiraFieldErrors,
    blockFormSubmission = _ref.blockFormSubmission,
    _ref$lifecycleHandler = _ref.lifecycleHandlers,
    lifecycleHandlers = _ref$lifecycleHandler === void 0 ? {} : _ref$lifecycleHandler;
  var _useFormSaveErrorsAct = useFormSaveErrorsActions(),
    setFromJiraFieldErrors = _useFormSaveErrorsAct.setFromJiraFieldErrors;
  useEffect(function () {
    if (portalCreateStore) {
      var _portalCreateStore$fo;
      portalCreateStore.reporterAccountId = reporterAccountId;
      (_portalCreateStore$fo = portalCreateStore.formStore) === null || _portalCreateStore$fo === void 0 || _portalCreateStore$fo.onFieldChange('reporter');
    }
  }, [portalCreateStore, reporterAccountId]);
  useEffect(function () {
    var formStore = portalCreateStore === null || portalCreateStore === void 0 ? void 0 : portalCreateStore.formStore;
    if (formStore && jiraFieldErrors) {
      setFromJiraFieldErrors(formStore, jiraFieldErrors);
    }
  }, [portalCreateStore === null || portalCreateStore === void 0 ? void 0 : portalCreateStore.formStore, jiraFieldErrors, setFromJiraFieldErrors]);
  return /*#__PURE__*/React.createElement("div", null, portalCreateStore.loadingForm && /*#__PURE__*/React.createElement(LoadingSpinner, null, /*#__PURE__*/React.createElement(FormattedMessage, IntlCommonMessages[CommonMessage.LoadingFormDetails])), portalCreateStore.formStore && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderForm, {
    formStore: portalCreateStore.formStore,
    ufoExperience: portalCreateProductExperience,
    blockFormSubmission: blockFormSubmission,
    displayMode: DisplayMode.Edit
  }), /*#__PURE__*/React.createElement(FormRenderSuccess, {
    lifecycleHandlers: lifecycleHandlers
  })));
};
export var PortalCreateObserved = observer(PortalCreate);